import * as Headless from "@headlessui/react";
import { clsx } from "clsx";
import { forwardRef, useEffect, useRef, useState } from "react";
export const Textarea = forwardRef(function Textarea(
  { className, showCharacterCount, resizable = true, unclickable = false, onChange, ...props },
  ref
) {
  const textareaRef = useRef(null);
  // Ajuste la hauteur du textarea en fonction de son contenu
  const adjustHeight = () => {
    const target = textareaRef.current || ref?.current;
    if (target) {
      target.style.height = "auto"; // Réinitialise la hauteur
      target.style.height = `${target.scrollHeight + 15}px`; // Réajuste à la hauteur du contenu
    }
  };
  // Gère les changements de texte et ajuste la hauteur
  const handleChange = (event) => {
    adjustHeight();
    if (onChange) {
      onChange(event);
    }
  };
  // Gère l'entrée de texte
  const handleInput = () => {
    adjustHeight();
  };
  // Ajuste la hauteur au premier rendu et à chaque changement de contenu
  useEffect(() => {
    adjustHeight();
  }, [textareaRef.current, ref?.current, props.value]); // Redimensionne si la valeur change
  return (
    <>
    <span
      data-slot="control"
      className={clsx([
        className,
        "relative block w-full", // Basic layout
        "before:absolute before:inset-px before:rounded-[calc(theme(borderRadius.lg)-1px)] before:bg-white before:shadow", // Shadow
        "dark:before:hidden", // Dark mode
        "after:pointer-events-none after:absolute after:inset-0 after:offset-0 after:rounded-lg after:ring-inset after:ring-purple sm:after:focus-within:ring-0 sm:after:focus-within:ring-purple outline-purple", // Focus styles
        "has-[[data-disabled]]:opacity-50 before:has-[[data-disabled]]:bg-zinc-950/5 before:has-[[data-disabled]]:shadow-none", // Disabled state
      ])}
    >
      <Headless.Textarea
        ref={ref || textareaRef}
        {...props}
        style={{
          whiteSpace: "pre-wrap",
          overflowWrap: "break-word",
          wordWrap: "break-word",
        }}
        onInput={handleInput}
        onChange={handleChange}
        className={clsx([
          "relative block w-full appearance-none rounded-lg px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing.3)-1px)] sm:py-[calc(theme(spacing[1.5])-1px)]", // Basic layout
          "text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6 dark:text-white", // Typography
          "border border-zinc-950/10 data-[hover]:border-zinc-950/20 dark:border-white/10 dark:data-[hover]:border-white/20", // Border styles
          "bg-transparent dark:bg-white/5", // Background color
          "focus:outline-none focus:ring-purple focus:border-purple", // Focus styles
          "data-[invalid]:border-red-500 data-[invalid]:data-[hover]:border-red-500 data-[invalid]:dark:border-red-600 data-[invalid]:data-[hover]:dark:border-red-600", // Invalid state
          "disabled:border-zinc-950/20 disabled:dark:border-white/15 disabled:dark:bg-white/[2.5%] dark:data-[hover]:disabled:border-white/15", // Disabled state
          resizable ? "resize-y" : "resize-none", // Resizable styles
          unclickable
            ? "pointer-events-none opacity-50 border-zinc-950/20 dark:border-white/15 dark:bg-white/[2.5%] dark:data-[hover]:border-white/15"
            : "", // Unclickable styles
        ])}
      />
    </span>
     {props.maxLength && showCharacterCount && (
      <span className="absolute right-8 text-zinc-500 mt-[-26px]">
        {props.value?.length ?? "0"}/{props.maxLength}
      </span>
    )}
    </>
  );
});
